/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import { TypedAction, TypedReducer, setWith } from "redoodle";
import { IUserPhoneNumberDocument, IUserState } from "./userState";

export const SET_USER_PHONE_NUMBER = TypedAction.define("user::SET_USER_PHONE_NUMBER")<{
    phoneNumberDocument: IUserPhoneNumberDocument | false;
}>();

export const SET_USER_INFO = TypedAction.define("user::SET_USER_INFO")<{
    userInfo: UserInfo | false;
}>();

export const userReducer = TypedReducer.builder<IUserState>()
    .withHandler(SET_USER_PHONE_NUMBER.TYPE, (state, { phoneNumberDocument }) => {
        return setWith(state, { phoneNumberDocument });
    })
    .withHandler(SET_USER_INFO.TYPE, (state, { userInfo }) => {
        return setWith(state, { userInfo });
    })
    .build();
